<template>
  <a-config-provider :locale="locale">
    <!-- <div v-if="isDev" style="width: 200px" @mouseleave="mouse(false)" @mouseover="mouse(true)">
      <span>菜单</span>
      <TdSidebarMenu :visible="visible"></TdSidebarMenu>
    </div> -->

    <a-spin v-bind="spinObject">
      <router-view v-if="routerState"></router-view>
    </a-spin>
  </a-config-provider>
</template>

<script setup>
  // 国际化
  import zhCN from 'ant-design-vue/es/locale/zh_CN'
  import dayjs from 'dayjs'
  import 'dayjs/locale/zh-cn'
  import { spinObject } from './pageApi/tip'
  import { ref, nextTick, provide } from 'vue'
  dayjs.locale('zh-cn')

  const locale = ref(zhCN)
  const routerState = ref(true)
  function reload() {
    routerState.value = false
    nextTick(() => (routerState.value = true))
  }
  provide('reload', reload)
</script>
<style scoped lang="less">
  :deep(.ant-spin-nested-loading > div > .ant-spin) {
    max-height: unset;
  }
</style>
